import { render, staticRenderFns } from "./UserDetail_TutorList.vue?vue&type=template&id=285f929c&"
import script from "./UserDetail_TutorList.vue?vue&type=script&lang=js&"
export * from "./UserDetail_TutorList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports